import type { WorkspaceTab } from '@/hooks/useWorkspaceTabs'

interface Props {
  active: WorkspaceTab
  draftCount: number
  onTab: (tab: WorkspaceTab) => void
  onDetect: () => void
}

const DOCK: { id: WorkspaceTab; label: string }[] = [
  { id: 'overview', label: 'Home' },
  { id: 'inbox', label: 'Inbox' },
  { id: 'automations', label: 'Flows' },
  { id: 'enterprise', label: 'Admin' }
]

export function MobileDock({ active, draftCount, onTab, onDetect }: Props) {
  return (
    <nav className="dock" aria-label="Primary">
      {DOCK.map((d) => (
        <button
          key={d.id}
          type="button"
          className={`dock-item${active === d.id ? ' on' : ''}`}
          onClick={() => onTab(d.id)}
        >
          <span className="dock-label">
            {d.label}
            {d.id === 'inbox' && draftCount > 0 ? (
              <span className="dock-badge">{draftCount > 99 ? '99+' : draftCount}</span>
            ) : null}
          </span>
        </button>
      ))}
      <button type="button" className="dock-item dock-primary" onClick={onDetect}>
        <span className="dock-label">Detect</span>
      </button>
    </nav>
  )
}
